import { useState, useEffect } from "react";
import validator from "validator";
import { format } from "date-fns";
import { getGeneralTypes, postData, postDataResponse } from "./Services";
import { StyledSelect, InputContainer, InputWrapper, HeaderContainer, HeaderText, NoteField, GreyButton, RedButton, RightJustifyDiv, SubmitSpan, divOverflowHidden, divFloatLeft, divFloatRight, StyledSelectLeft, StyledSelectRight } from "./Style";
import { useMsal } from "@azure/msal-react";
//import { Grid, TextField, Button, Card, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material/';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';

import { Grid, TextField, Backdrop, Button, Card, CircularProgress, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material/';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useNavigate } from 'react-router-dom';
import ConfirmDialog from "./ConfirmDialog";


const PersonnelRateForm = ({ onSave, Case = {} }) => {

    const [userEmail, setUserEmail] = useState('');
    const [MatterID, setMatterID] = useState([]);
    const [RateData, setRateData] = useState([]);
    const [SelectedRateData, setSelectedRateData] = useState([]);
    const [selectedValueMatterID, setSelectedValueMatterID] = useState("");
    const [errorRequest, setErrorRequest] = useState(false);
    const [dialogDestUrl,  setDialogDestUrl] = useState("");
    const { instance } = useMsal();



    useEffect(() => {
        async function fetchInitialData(_email) {
            const currentAccount = instance.getActiveAccount();
            var body = {};
            if (currentAccount) {
                setUserEmail(currentAccount.username);
                body.email = currentAccount.username;
            }
            const tokenRequest = {
                account: currentAccount, // This is an example - Select account based on your app's requirements
                scopes: ["User.Read"]
            }
            const matterIDResponse = await postDataResponse('/Invoice/GetPersonnelRates', body);  //await getMatterID(body.email);
            const matterList = matterIDResponse.data.filter((value, index, self) =>
                index === self.findIndex((t) => (
                    t.matterID === value.matterID && t.matterDescription === value.matterDescription
                ))
            ).map(obj => ({ id: obj.matterID, name: obj.matterDescription }));
            matterIDResponse.errors ? setErrorRequest(true) : setMatterID(matterList);

            /*matterIDResponse.errors ? setErrorRequest(true) : 
               setMatterID(
                   matterIDResponse.data.map(obj => ({
                       id: obj.matterID,
                       name: obj.matterDescription
               }))
           );*/

           const updatedRateData = matterIDResponse.data.map((row) => ({id: uuidv4(), ...row}));

            setRateData(updatedRateData);
            setSelectedRateData(updatedRateData);
            setSelectedValueMatterID("ALL");
        }
        fetchInitialData();
    }, [instance, userEmail]);

    //Handler MatterID
    const handleSelectChangeMatterID = (event) => {
        setSelectedValueMatterID(event.target.value);

        console.log(event.target.value);
        console.log(selectedValueMatterID);

        if (event.target.value == "") {
            setSelectedRateData([]);
        }

        if (event.target.value == "ALL") {
            setSelectedRateData(RateData);
        }

        if (event.target.value != "" && event.target.value != "ALL") {
            setSelectedRateData(RateData.filter(x => x.matterID === event.target.value));
        }
    };

    const columns = [
        { field: 'matterID', headerName: 'Matter ID', width: 150 },
        { field: 'fullName', headerName: 'Full Name',width: 150 },
        { field: 'type', headerName: 'Type', },
        { field: 'effectiveDate', headerName: 'Effective Date',width: 150 },
        { field: 'rate', headerName: 'Rate', type: 'number', },

    ];

    const uuidv4 = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };

const paginationModel = { page: 0, pageSize: 20 };
    return (
        <form>
            <div>
                <Card className="form-card">
                    <CardHeader title="Personnel Rates" style={{ backgroundColor: "#8B0E04", color: "#fff" }} />
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={9}>
                                <FormControl fullWidth margin="normal">
                                    <InputLabel id="MatterIDSelectLbl">Matter ID</InputLabel>
                                    <Select
                                        labelId="MatterIDSelectLbl"
                                        id="MatterIDSelect"
                                        name="MatterIDSelect"
                                        value={selectedValueMatterID}
                                        label="Matter ID"
                                        onChange={handleSelectChangeMatterID}
                                        required
                                    >
                                        <MenuItem value="ALL">All Professional Rates</MenuItem>
                                        {MatterID !== null ? MatterID.map((value) => (
                                            <MenuItem key={value.id} value={value.id}>
                                                {value.name}
                                            </MenuItem >
                                        )) : <MenuItem ></MenuItem >}

                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={9}>
                                <Paper sx={{ width: '100%' }}>
                                    <DataGrid
                                        rows={SelectedRateData}
                                        columns={columns}                     
                                        initialState={{ pagination: { paginationModel } }}
                                        pageSizeOptions={[5, 10, 15, 20]}
                                        sx={{ border: 0 }}
                                    />
                                </Paper>
                                {/*<TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Matter ID</TableCell>
                                                <TableCell>Full Name</TableCell>
                                                <TableCell>Type</TableCell>
                                                <TableCell>Effective Date</TableCell>
                                                <TableCell>Rate</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {SelectedRateData.map((row) => (
                                                <TableRow
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {row.matterID}
                                                    </TableCell>
                                                    <TableCell>{row.fullName}</TableCell>
                                                    <TableCell>{row.type}</TableCell>
                                                    <TableCell>{row.effectiveDate}</TableCell>
                                                    <TableCell align="right">{row.rate}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>*/}

                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </div>
        </form>
    );
};
export default PersonnelRateForm;